import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgSuperbottleGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M28.927 11.956C28.732 10.618 26.397 10 23.964 10c-2.434 0-4.77.618-4.964 1.956V35.838C19 37.28 21.53 38 23.963 38c2.434 0 4.964-.618 4.964-2.162V12.162c.097-.103.097-.206 0-.206Zm-8.37 0c.487-.309 1.655-.618 3.504-.618s3.017.31 3.503.618l.195.206c-.292.206-1.557.823-3.796.823-2.238 0-3.503-.617-3.698-.823 0-.103.098-.206.292-.206Zm-.39 1.647c.974.412 2.337.618 3.796.618 1.46 0 2.823-.206 3.796-.618v7.515c-.097.309-1.362.926-3.796.926-2.433 0-3.698-.617-3.795-.823v-7.618Zm3.796 23.059c-2.335 0-3.6-.618-3.795-.824v-13.28c.973.413 2.336.619 3.796.619 1.362 0 2.822-.206 3.795-.618v13.176c-.097.31-1.362.927-3.796.927Z",
    fill: "currentColor"
  }));
}

export { SvgSuperbottleGlyph as default };
